const config: any = {};

Object.keys(process.env).forEach((value) => {
    if (value.startsWith('REACT_APP_')) {
        config[value.slice(10)] = process.env[value] || '';
    }
})

export default config;
